<template lang="en">
  <div class="End" id="End">
    <div class="endk">
      <span>©2022 &nbsp;Tom Clancys The Division 2(WeaponDamageCalculator)</span>
    </div>
    <br/>
    <div class="endk">
      <span>By:MOTH_56&nbsp; &nbsp; or&nbsp; &nbsp; MengXindd</span>
    </div>
    <br/>
    <div class="endk">
      <span>特别感谢:&nbsp; &nbsp;h4xor343 &nbsp; &nbsp; Khperi.- &nbsp; &nbsp;Kujo._.Jotaro &nbsp; &nbsp;Reddit</span>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
@media screen and (min-width: 730px) {
  .End {
    background-color: rgba(255, 166, 0, 0.05);
    padding: 0.5%;
    position: relative;
    margin: 50px auto 0;
    border-top: 2px solid orange;
    text-align: center;
  }

  .endk {
    display: inline-block;
    margin: 0 0 0 1%;
  }

  .endk span {
    font-size: 18px;
    color: black;
    font-family: 'myfont';
    display: inline-block;
  }
}
@media screen and (max-width: 730px) {
  .End {
    display: none;
  }
}
</style>
